import { NotificationSetting } from '@/features/notification_setting';
import { FC } from 'react';

const NotificationSettingPage: FC = () => {
  return <NotificationSetting />;
};

export default NotificationSettingPage;
